<div class="chart-wrapper">
  <!-- Header with steps -->
  <nz-card>
    <div class="stepper">
      <nz-steps [nzCurrent]="stepper">
        <nz-step nzTitle="Select Data"></nz-step>
        <nz-step nzTitle="Build Chart"></nz-step>
      </nz-steps>
    </div>

    <!-- Loading state for chart editing -->
    <div *ngIf="isLoadingChart" class="loading-container">
      <nz-spin [nzSpinning]="isLoadingChart" nzSize="large">
        <div class="loading-content">
          <p>Loading chart...</p>
        </div>
      </nz-spin>
    </div>

    <!-- Main content: Step 1 -->
    <app-chart-data-preparer
      *ngIf="stepper === 0 && !isLoadingChart"
      (goToNextStep)="goToNextStep()"
    ></app-chart-data-preparer>

    <!-- Main content: Step 2 -->
    <app-chart-details *ngIf="stepper === 1 && !isLoadingChart" (backEvent)="back()"></app-chart-details>
  </nz-card>
</div>
